import { Divider, Modal } from '@nike/eds';
import {
  ButtonStyled,
} from '@nike/nike-design-system-components';
import PropTypes from 'prop-types';
import React from 'react';

const PopupConfirm = ({
  customConfirmAction,
  isOpen,
  closeModal,
  submitModel,
  content,
  confirmText,
  cancelText,
  title,
  headerIcon
}) => {
  const Actions = (
    <div className="d-sm-flx flx-jc-sm-fe p2-sm" style={{ gap: '20px' }}>
      {customConfirmAction}
      {!customConfirmAction && confirmText && (
        <ButtonStyled
          appearance="primary"
          className="responsive-btn"
          onClick={submitModel || closeModal || {}}
        >
          {confirmText}
        </ButtonStyled>
      )}

      {cancelText && (
      <div className="btn-cancel">
        <ButtonStyled
          appearance="secondary"
          className="responsive-btn"
          onClick={closeModal}
        >
          {cancelText}
        </ButtonStyled>
      </div>
      )}
    </div>
    );

  return (
    <Modal
      footerSlot={Actions}
      headerSlot={(
        <div
          className="ncss-container"
          id="modal-header"
          style={{ minWidth: '400px' }}
        >{headerIcon}
          <div className="ncss-row d-sm-flx flx-ai-sm-c mb3-sm">
            <div className="ncss-col-sm-12 ta-sm-c">
              <h1 className="eds-type--title-6">{title}</h1>
            </div>
          </div>
          <Divider />
        </div>
           )}
      isOpen={isOpen}
      onDismiss={closeModal}
    >
      <div className="ncss-container modal-body">
        <div className="ncss-row" style={{ maxWidth: '600px', minWidth: '200px' }}>
          <div className="ncss-col-sm-12 ta-sm-l">
            {content}
          </div>
        </div>
      </div>
    </Modal>
  );
};

PopupConfirm.defaultProps = {
  cancelText: '',
  closeModal: false,
  confirmText: '',
  customConfirmAction: '',
  headerIcon: <></>,
  isOpen: false,
  submitModel: false,
  title: ''
};

PopupConfirm.propTypes = {
  cancelText: PropTypes.string,
  closeModal: PropTypes.func,
  confirmText: PropTypes.string,
  content: PropTypes.node.isRequired,
  customConfirmAction: PropTypes.node,
  headerIcon: PropTypes.node,
  isOpen: PropTypes.bool,
  submitModel: PropTypes.func,
  title: PropTypes.string,
};

export default PopupConfirm;
